import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './ShipInputNumberField.scss'
import { getParsedValue, isNullOrUndefined } from '../../../../utils/general'

export default class ShipInputNumberField extends PureComponent {
  static propTypes = {
    category: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    value: PropTypes.number,
    onFormInputShipChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="ship-detail-group">
        <label className={`ship-detail category ${this.props.error ? 'error' : ''}`} htmlFor={this.props.name}>
          {this.props.category}
          {this.props.required ? ' *' : null}
        </label>
        <input
          className={`input-field ${this.props.error ? 'error' : ''}`}
          value={!isNullOrUndefined(this.props.value) ? this.props.value : ''}
          onChange={this.handleChange}
          id={this.props.name}
          type="number"
          disabled={this.props.readOnly === true}
        />
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  handleChange = event => {
    const value = getParsedValue(event.target.value)

    this.props.onFormInputShipChange(value, this.props.name)
  }
}
